<div class="c-wrapper">
    <div class="c-n-wrapper">
        <span multilang class="c-title">{{datas?.FeWoDetailsResponse?.Titel}}</span>
        <span multilang class="c-subtitle">{{datas?.FeWoDetailsResponse?.Ort}}
            {{datas?.FeWoDetailsResponse?.Region_Name}}
            {{datas?.FeWoDetailsResponse?.Land_Name}}
        </span>
    </div>
    <ng-container *ngIf="datas?.extracomment?.length > 0">
        <div class="c-block">
            <div class="c-item">
                <span multilang class="c-item-title">Extra info</span>
                <div class="v-wrapper">
                    <pre class="ml pree">{{datas?.extracomment}}</pre>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="c-block">
        <ng-container *ngFor="let cont of datas?.FeWoDetailsResponse?.TextBloecke?.TextBlock">
            <div class="c-item">
                <span multilang *ngIf="cont.$?.TextTitel?.length > 0" class="c-item-title">{{cont.$?.TextTitel |
                    cleanText}}</span>
                <div multilang deeplMode='html' [innerHtml]="cont._ | cleanText | safehtml" class="c-content">
                </div>
            </div>
        </ng-container>
    </div>

    <div class="f-btn-wrapper">
        <button class="f-btn" matRipple (click)="sendAnmeldung()">Jetzt buchen</button>
    </div>
</div>

<div class="fixedlefttop">
    <button class="f-b-top" matRipple (click)="sendAnmeldung()">Jetzt buchen</button>
</div>